// extracted by mini-css-extract-plugin
export default {"Box":"SimpleBox_Box__7uSxA"};